// extracted by mini-css-extract-plugin
export var title = "styles-module--title--3a7d1";
export var titleContainer = "styles-module--titleContainer--f2d40";